import React from 'react';
import * as TotemActions from '../actions/TotemActions';
import TotemStore from '../stores/TotemStore';

class PromoComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            name: '',
            email: '',
            isValid: false
        };
    }

    _handleSendInformation() {
        let { name, email } = this.state;
        this.setState({
            loading: true
        });
        TotemActions.sendPromo(name, email, this.props.article.name, this.sendPromoCallback.bind(this));
    }

    sendPromoCallback() {
        this.setState({
            name: '',
            email: ''
        });
        this.props.cancelModal(); //cierra el modal
    }

    _handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
            isValid: (this.state.name !== '' && this.state.email !== '')
        });
    }

    _onCancelModal() {
        this.setState({
            name: '',
            email: ''
        });
        this.props.cancelModal()
    }

    render() {

        return (
            <div id="promoModal" className="modal">
                <div className="modal-content">
                    <img className="hide-on-mobile" src={this.props.article.images[0]} />
                    <h3>Promoción disponible!!</h3>
                    <p>Participe de un sorteo por un <strong>{this.props.article.name}</strong> ingresando sus datos en el siguiente formulario. Le enviaremos un mail con los pasos a seguir.</p>
                    <div className="row">
                        <div className="input-field">
                            <label htmlFor="name">Nombre completo</label>
                            <input type="text" name="name" value={this.state.name} onChange={this._handleInputChange.bind(this)} />
                        </div>
                        <div className="input-field">
                            <label htmlFor="email">Dirección de email</label>
                            <input type="text" name="email" value={this.state.email} onChange={this._handleInputChange.bind(this)} />
                        </div>
                    </div>
                </div>
                <div className="modal-footer right-align">
                    <button className={this.state.isValid ? 'btn green' : 'btn disabled'} onClick={this._handleSendInformation.bind(this)}>Participar en promoción<label><i className="fa fa-check" aria-hidden="true"></i></label></button>
                    <button className="btn red" onClick={this._onCancelModal.bind(this)}>Cancelar<label><i className="fa fa-ban" aria-hidden="true"></i></label></button>                    
                </div>
            </div>
        );
    }
}

export default PromoComponent;


// WEBPACK FOOTER //
// ./src/components/PromoComponent.js